import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { BadgeGrey } from "../../../../../components/badge/Badge";
import { Card, Icon } from "@sellar-io/components";
import { Toast } from "../../../../../components/toast/Toast";
import { useToast } from "../../../../../components/toast/useToast.shared";

type StorefrontSupplierAWRSAndVATCardProps = {
  supplier: SupplierGetResponseType;
};
export const StorefrontSupplierAWRSAndVATCard = ({
  supplier,
}: StorefrontSupplierAWRSAndVATCardProps) => {
  const supplierBusinessName = supplier.Business.registeredCompanyName;
  const supplierAWRSNumber = supplier.Business.awrsNumber;
  const supplierVATNumber = supplier.Business.vatNumber;

  return (
    <Card className="flex flex-col gap-4 rounded-md bg-white p-4 xl:border">
      <BadgeGrey icon="ACCOUNT_SUPERVISOR">Supplier details</BadgeGrey>
      {supplierBusinessName && (
        <Copyable title="Business name" value={supplierBusinessName} />
      )}
      {supplierAWRSNumber && (
        <Copyable title="AWRS Number" value={supplierAWRSNumber} />
      )}
      {supplierVATNumber && (
        <Copyable title="VAT Number" value={supplierVATNumber} />
      )}
    </Card>
  );
};

type CopyableProps = {
  title: string;
  value: string;
};
const Copyable = ({ value, title }: CopyableProps) => {
  const { toast } = useToast();
  return (
    <div className="flex flex-col">
      <strong>{title}</strong>
      <div
        onClick={() => {
          toast({
            placement: "bottom",
            render: () => (
              <Toast icon="CONTENT_COPY">{`${title} copied`}</Toast>
            ),
          });
          navigator.clipboard.writeText(`${title}: ${value}`);
        }}
        className="flex cursor-pointer items-center gap-2"
      >
        <span>{value}</span>
        <Icon size={0.7} icon="CONTENT_COPY_OUTLINE" />
      </div>
    </div>
  );
};
